import { AgentDashboard } from '@sales-app/types/AgentDashboard'
import { SupervisorDashboard } from '@sales-app/types/SupervisorDashboard'
import { gql } from 'graphql-request'

export namespace SalesDashboardQueries {
  export namespace GET_SUPERVISOR_DASHBOARD {
    export type Response = { supervisorDashboard: SupervisorDashboard | null }
  }

  export namespace GET_AGENT_DASHBOARD {
    export type Response = { agentDashboard: AgentDashboard | null }
  }

  export function getSupervisorDashboard() {
    return gql`
      query getSupervisorDashboard($filter: SupervisorDashboardFilter) {
        supervisorDashboard(filter: $filter) {
          dashboardStats {
            potentialBookingsWorked
            reservationsCreated
            potentialDuplicates
            potentialBookingsNotContacted1Day
            potentialBookingsMoveIn2Weeks
          }
          potentialBookingsSummary {
            agent {
              id
              name
              currentStatus
            }
            potentialBookingsByStatus {
              applicationStarted
              automatedFirstContact
              followUp
              needsAction
              new
            }
          }
        }
      }
    `
  }

  export function getAgentDashboard() {
    return gql`
      query getAgentDashboard($filter: AgentDashboardFilter) {
        agentDashboard(filter: $filter) {
          dashboardStats {
            agentConversionRate
            unassignedPotentialBookings
            potentialBookingsWithUpcomingMoveIns
            potentialBookingsNotContacted
            hotMarkets {
              displayCity {
                id
                name
              }
              potentialBookingsCount
            }
          }
          potentialBookings {
            id
            bookablePerson
            bookablePersonType
            bookablePersonId
            displayCity
            potentialBookingStatus
            potentialBookingSource
          }
        }
      }
    `
  }
}
